import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { InvoiceFilterModel } from '../../../super-admin/models/client';
import { CommonService } from '../../../../shared/services/common/common.service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { ErrorhandlerService } from '../../../../shared/services/errorhandler/errorhandler.service';
import { AngularCsv } from 'angular7-csv';

@Component({
  selector: 'app-storeadmin-invoicelist',
  templateUrl: './storeadmin-invoicelist.component.html',
  styleUrls: ['./storeadmin-invoicelist.component.css']
})
export class StoreadminInvoicelistComponent implements OnInit {

  InvoiceList: any[] = [];
  InvoiceListCount = 0;
  searchForm: FormGroup;
  isDisplay = 'none';
  clientFilterModel!: InvoiceFilterModel;
  constructor(private commonService: CommonService, private notificationService: NotificationService, private loader: LoaderService, private errorhandlerService: ErrorhandlerService, private formBuilder: FormBuilder) {

  }

  initialize() {
    this.searchForm = this.formBuilder.group({
      searchList: [''],
      startDate: [null],
      endDate: [null]
    });
    this.fn_resetList();
  }
  
  ngOnInit() {
    this.initialize();
    this.fn_GetInvoiceList();
  }

  fn_clearFilter(){
    this.initialize();
    this.fn_GetInvoiceList();
  }

  fn_resetList() {
    this.InvoiceList = [];
    this.InvoiceListCount = 0;
    this.clientFilterModel = {
      Skip: 0,
      Take: 10,
      searchBy: '',
      startDate: null,
      endDate: null,
      export: false,
      userId: localStorage["userId"],
      storeId: localStorage["storeId"]
    };
  }
  fn_GetInvoiceList() {
    this.loader.show();
    this.clientFilterModel.Skip = this.InvoiceListCount;
    this.commonService.getInvoiceList(this.clientFilterModel).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
      } else if (res.StatusCode === 204) {
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });

  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    this.loader.show();
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.InvoiceList.find(x => x.InvoiceNumber === items[i].InvoiceNumber)) {
          this.InvoiceListCount = this.InvoiceList.push(items[i]);
        }
      }
    }
    this.isDisplay = this.InvoiceListCount > 0 ? 'none' : 'block';
    this.loader.hide();
  }

  fn_searchClient(form: FormGroup) {
    this.InvoiceList = [];
    this.InvoiceListCount = 0;
    this.clientFilterModel.searchBy = form.controls['searchList'].value;
    this.clientFilterModel.startDate = form.controls['startDate'].value ? String(new Date(form.controls['startDate'].value).toLocaleDateString('en-GB')) : null;
    this.clientFilterModel.endDate = form.controls['endDate'].value ? String(new Date(form.controls['endDate'].value).toLocaleDateString('en-GB')) : null;
    this.fn_GetInvoiceList();
  }
  showPdf(invoice: any) {
    this.loader.show()
    this.commonService.getDetailedInvoice(invoice, localStorage["userId"]).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        const linkSource = 'data:application/pdf;base64,' + res.Data.ResponseData;
        const downloadLink = document.createElement("a");
        const fileName = "invoice.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.notificationService.success("Invoice download successfuly", "Success")
      } else {
        this.notificationService.success("Failed to  download", "Error")
      }
      this.loader.hide();
    }, (err: any) => {

      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });

  }

  fn_downloadExcel(form: FormGroup) {
    this.loader.show();
    this.clientFilterModel.export = true;
    this.commonService.getInvoiceList(this.clientFilterModel).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_downloadInvoiceReport(res.Data.ResponseData);
      } else {
        this.notificationService.error("Failed to  download", "Error")
      }

      this.loader.hide();
      this.clientFilterModel.export = false;
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
      this.clientFilterModel.export = false;
    });
  }

  fn_downloadInvoiceReport(invoiceList:any) {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true,
      noDownload: false,
      headers: ['Invoice number', 'Sales order', 'Customer PO', 'Date', 'Due date','Total($)','Balance($)','Invoice date from']
    };
    // tslint:disable-next-line:no-unused-expression
    new AngularCsv(invoiceList, 'InvoiceReport', options);
  }
}
